exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  z-index: 4000;\n  width: 100%;\n  height: 30px;\n  display: block; }\n\ninput {\n  padding-right: 30px;\n  padding-top: 10px; }\n\n::ng-deep\n.autocomplete-icon {\n  color: #BABBC7; }\n\n.oi-caret-bottom {\n  font-size: 8px; }\n\n.oi-x {\n  cursor: pointer;\n  position: absolute;\n  right: 12px;\n  top: 11px;\n  font-size: 9px; }\n\n.form-group {\n  margin-bottom: 0; }\n  .form-group .form-control-feedback {\n    top: -1px; }\n\n.results-wrapper {\n  height: 0;\n  overflow: visible; }\n  .results-wrapper .results {\n    margin: 2px 0 0 0;\n    position: relative;\n    max-height: 300px;\n    overflow: auto;\n    width: 100%;\n    background-color: #FEFEFE;\n    z-index: 3;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 12px;\n    font-weight: 400; }\n  .results-wrapper .result {\n    padding: 7px 20px;\n    cursor: pointer; }\n  .results-wrapper .selected {\n    background-color: #eee; }\n  .results-wrapper .empty-result {\n    font-style: italic;\n    color: #e22d43; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/autocomplete/autocomplete.scss
// module id = ../../../../../src/app/shared/components/autocomplete/autocomplete.scss
// module chunks = 12